import { Footer } from '@/layouts/MainLayout/Footer'
import { useRestClient } from '@/contexts/QueryProvider'
import { useMemo } from 'react'
import { groupPlatformItems } from './groupPlatformItems'
import { selectFeaturedApps } from './selectFeaturedApps'
import { BenefitsSection } from './sections/BenefitsSection'
import { ContactSection } from './sections/ContactSection'
import { FeaturedAppsSection } from './sections/FeaturedAppsSection'
import { GetStartedSection } from './sections/GetStartedSection'
import { HeroSection } from './sections/HeroSection'
import { OurEdgeSection } from './sections/OurEdgeSection'
import { TerminologySection } from './sections/TerminologySection'

export function HomePageV2() {
  const { getLandingApiGetPlatformExternal, getLandingApiGetApplicationExternal } = useRestClient()
  const { data: platform } = getLandingApiGetPlatformExternal.useSuspenseQuery(undefined)
  const { data: apps } = getLandingApiGetApplicationExternal.useSuspenseQuery(undefined)

  const groups = useMemo(() => groupPlatformItems(platform ?? []), [platform])
  const featuredApps = useMemo(() => selectFeaturedApps(apps ?? []), [apps])

  return (
    <div className="bg-background">
      <HeroSection />
      {groups.benefits.length > 0 && <BenefitsSection items={groups.benefits} />}
      {groups.ourEdge.length > 0 && <OurEdgeSection items={groups.ourEdge} />}
      {featuredApps.length > 0 && <FeaturedAppsSection apps={featuredApps} />}
      {groups.getStarted.length > 0 && <GetStartedSection items={groups.getStarted} />}
      {groups.terminology.length > 0 && <TerminologySection items={groups.terminology} />}
      {groups.contacts.length > 0 && <ContactSection items={groups.contacts} />}
      <Footer />
    </div>
  )
}
